import { GET } from "../../APiHelper/API";

export const getLeagueById = (league_id, onSuccess, onError) => {
  GET(`/api/v1/leagues/by_id/${league_id}`, onSuccess, onError);
};
